// frontend/src/pages/Admin/AdminClosureManagementPage.jsx
import React from 'react';
import FacilityClosureManager from '../../components/Admin/FacilityClosureManager';
import styles from './AdminClosureManagementPage.module.css';

const AdminClosureManagementPage = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className="page-main-title">Facility Closures</h2>
                <p className={styles.description}>
                    Manage dedicated time blocks where the facility is unavailable for reservations (e.g., maintenance, holidays).
                </p>
            </div>

            <section className={styles.section}>
                <FacilityClosureManager />
            </section>
        </div>
    );
};

export default AdminClosureManagementPage;
